<!-- Footer -->
<p class="clearfix mb-0  d-flex justify-content-center">
    <span class="float-md-left d-block d-md-inline-block mt-25">
  COPYRIGHT &copy; {{ year }}
  <span class="ml-25">Global RedPyme</span>
  <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
</p>
<!--/ Footer -->

<!-- Move to top Button-->
<app-scroll-top *ngIf="coreConfig.layout.scrollTop"></app-scroll-top>

<!-- Buynow Button-->
<app-need-help [href]="'https://walink.co/9e8a9d'"> </app-need-help>
